module.exports = __webpack_public_path__ + "img/国家顶级节点标识首页_19.f09e17c7.jpg";